import { connect } from 'react-redux';
import get from 'lodash.get';
import Global from '../../../../store/global-selectors';
import { OtherShippingOptionsService } from '../../../../services/other-shipping-options/other-shipping-options-service';
import { ReturnDetailsModalContent } from './index';

const mapStatesToProps = (state, props) => {
  const { returnId, returnDetailModalId } = props;
  const returnDetailsModalData = Global.selectReturnDetailsReturnDetailsByReturnDetailModalId(state, {
    returnDetailModalId,
  });
  const isLoading = get(returnDetailsModalData, 'isLoading', true);
  const returnShipment = get(returnDetailsModalData, 'returnShipment', {});
  const returnConfiguration = get(returnShipment, 'returnConfiguration', {});
  const { shipFromId, packages } = returnConfiguration;
  const packageType = get(Global.selectSellerPackageType(state, { packages }), 'name');
  const shipTo = get(Global.selectSellerShipFromsById(state, { shipFromId }), 'name');
  const shipmentHasOptions = returnConfiguration && returnConfiguration.options;

  if (shipmentHasOptions) {
    const selectedService = Global.selectSellerServiceById(state, {
      serviceId: returnConfiguration.serviceId,
    });
    const carriers = Global.selectReferenceDatagetSellerCarriers(state);
    returnShipment.returnConfiguration = {
      ...returnConfiguration,
      options: {
        ...returnConfiguration.options,
        confirmation: OtherShippingOptionsService.getConfirmationText(returnConfiguration, carriers, selectedService),
      },
    };
  }

  return {
    returnShipment,
    isLoading,
    returnId,
    shipTo,
    packageType,
  };
};

export const ReturnDetailsModalContentContainer = connect(mapStatesToProps)(ReturnDetailsModalContent);
